<script>
import OwTable from '@/components/common/OwTable';
import TableRow from '@/components/statistics/users/TableRow';

export default {
    name: 'StatisticsUsersTable',
    extends: OwTable,
    props: {
        headers: {
            type: Array,
            default: () => [
                'id', 'first_name', 'last_name', 'matches_count', 'wins_count', 'losses_count', 'squares_count',
            ],
        },
        tableRowComponent: {
            type: Object,
            default: () => TableRow,
        },
    },
};
</script>
